/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LogMeetingResult
 */
export interface LogMeetingResult {
  /**
   *
   * @type {string}
   * @memberof LogMeetingResult
   */
  carrierMeetingId: string;
  /**
   *
   * @type {number}
   * @memberof LogMeetingResult
   */
  createdTodoCount: number;
  /**
   *
   * @type {number}
   * @memberof LogMeetingResult
   */
  skippedTodoCount: number;
}

/**
 * Check if a given object implements the LogMeetingResult interface.
 */
export function instanceOfLogMeetingResult(
  value: object,
): value is LogMeetingResult {
  if (!("carrierMeetingId" in value) || value["carrierMeetingId"] === undefined)
    return false;
  if (!("createdTodoCount" in value) || value["createdTodoCount"] === undefined)
    return false;
  if (!("skippedTodoCount" in value) || value["skippedTodoCount"] === undefined)
    return false;
  return true;
}

export function LogMeetingResultFromJSON(json: any): LogMeetingResult {
  return LogMeetingResultFromJSONTyped(json, false);
}

export function LogMeetingResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogMeetingResult {
  if (json == null) {
    return json;
  }
  return {
    carrierMeetingId: json["carrierMeetingId"],
    createdTodoCount: json["createdTodoCount"],
    skippedTodoCount: json["skippedTodoCount"],
  };
}

export function LogMeetingResultToJSON(json: any): LogMeetingResult {
  return LogMeetingResultToJSONTyped(json, false);
}

export function LogMeetingResultToJSONTyped(
  value?: LogMeetingResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierMeetingId: value["carrierMeetingId"],
    createdTodoCount: value["createdTodoCount"],
    skippedTodoCount: value["skippedTodoCount"],
  };
}
